export const api = {
    GET_OPERATIONS_LIST_API: "/api/operations/list",
    GET_OPERATIONS_REPORT_API: "/api/operations/report"
}